import dayjs from "dayjs"

const formatNumber = (val: number, prefix = '.') => {
  if (!val) return '0'

  if (prefix === ',') {
    return new Intl.NumberFormat().format(val)
  }

  return new Intl.NumberFormat('it-IT').format(val)
}

function formatCurrency(val: number, prefix = 'đ') {
  if (!val) return `0${prefix}`
  return `${new Intl.NumberFormat('it-IT').format(val)}${prefix}`
}

export { formatNumber, formatCurrency }

export function formatTimeInput(datetime: string) {
  if (!datetime) return '-'
  return dayjs(datetime).format('HH:mm')
}
